import * as React from 'react';
import * as styles from './Button.css';
import { Helper } from '../../Helper';
import { IAIcon } from '../icon';
import { LoggingService } from '../../services/LoggingService';
import "../../styles/BasicIA.css";

export interface IIAButtonProps {
  label?: string;
  arialable?: string;
  buttonColor?: string;
  borderColor?: string;
  mouseOverButtonColor?: string;
  textColor?: string;
  icon?: string;
  iconColor?: string;
  iconMarginTop?: number
  height?: number;
  showSpinner?: boolean;
  disbaled?: boolean;
  fixedSize?: string;
  hasFixedSize?: boolean;
  fontSize?: number;
  style?: React.CSSProperties;
  styleLabel?: React.CSSProperties;
  borderRadius?: number;
  selected?: string;
  darkMode?: boolean;
  onClick?: () => void;
  dataAutomationId?: string,
  onChange?: (option: string) => void;
}

export interface IIAButtonState {
  mouseOver: boolean;
}

export class IAButton extends React.Component<IIAButtonProps, IIAButtonState> {

  constructor(props: IIAButtonProps) {
    super(props);
    this.state = {
      mouseOver: false
    }
  }

  public render(): JSX.Element {
    let backgroundColor = this.props.buttonColor != undefined ? this.props.buttonColor : "transparent";
    if (this.props.showSpinner) {
      backgroundColor = this.props.darkMode ? "#414141" : "#eeeeee";
    }
    return (
      <button
        disabled={this.props.showSpinner}
        onClick={() => {
          if (!this.props.disbaled) {
            this.props.onClick();
          }
        }}
        onMouseOver={() => this.setState({ mouseOver: true })}
        onMouseLeave={() => this.setState({ mouseOver: false })}
        className={[styles.IA_button, "IA_OnFocus"].join(" ")}
        style={{
          backgroundColor: this.state.mouseOver && this.props.mouseOverButtonColor ? this.props.mouseOverButtonColor : backgroundColor,
          color: this.props.textColor != undefined ? this.props.textColor : Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.buttonColor != undefined ? this.props.buttonColor : "transparent", "#ffffff", "#333333"),
          height: this.props.height != undefined ? this.props.height : 30,
          padding: this.props.buttonColor == undefined || this.props.label == undefined ? 0 : (this.props.hasFixedSize ? this.props.fixedSize : (this.props.icon != undefined ? "0px 20px 0px 20px" : "0px 20px")),
          opacity: this.props.disbaled != undefined && this.props.disbaled ? 0.5 : 1,
          fontSize: this.props.fontSize != undefined ? this.props.fontSize : 12,
          lineHeight: this.props.height != undefined ? `${this.props.height}px` : "30px",
          cursor: this.props.disbaled ? "default" : "pointer",
          borderRadius: this.props.borderRadius,
          border: this.props.borderColor ? `1px solid ${this.props.borderColor}` : "none",
          ...this.props.style
        }}
        data-automation-id={this.props.dataAutomationId}
        aria-label={this.props.arialable != undefined ? this.props.arialable : "Button"}
      >
        {this.props.showSpinner ?
          <div
            className={styles.spinner}
          >
            <IAIcon
              title="Spinner"
              size={20}
              color={"#ffffff"}
            />
          </div>
          :
          <div>
            {this.props.icon != undefined &&
              <div
                className={styles.icon}
                style={{
                  marginTop: this.props.iconMarginTop ?? (this.props.buttonColor && this.props.buttonColor !== "transparent" ? 4 : 0),
                  paddingLeft: this.props.label == undefined || this.props.label == null ? 5 : "0px",
                  paddingRight: this.props.label == undefined || this.props.label == null ? 0 : "2px",
                  cursor: this.props.disbaled ? "default" : "pointer"
                }}
              >
                <IAIcon
                  title={this.props.icon}
                  size={22}
                  color={this.props.iconColor != undefined ? this.props.iconColor : Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.buttonColor != undefined || this.props.buttonColor == null ? this.props.buttonColor : "#333333", "#ffffff", "#333333")}
                />
              </div>
            }
            <div
              className={!this.props.styleLabel ? styles.label : undefined}
              style={{
                float: this.props.icon != undefined ? "left" : "none",
                ...this.props.styleLabel
              }}>
              {this.props.label}
            </div>
          </div>
        }
      </button>
    );
  }

  public componentDidCatch(error) {
    LoggingService.trackException(this.constructor.name, "componentDidCatch", error);
  }
}